import React from 'react';
import { Link } from 'react-router-dom';
import './InfoPage.css';

function Help() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Central de Ajuda</h1>

        <section className="info-section">
          <h2>Como podemos ajudá-lo?</h2>
          <p>Bem-vindo à Central de Ajuda da Nukki. Encontre respostas para perguntas comuns e obtenha suporte.</p>
        </section>

        <section className="info-section">
          <h3>Para Hóspedes</h3>
          <div className="help-topics">
            <div className="help-topic">
              <h4>Reservas</h4>
              <ul>
                <li>Como reservar uma propriedade</li>
                <li>Modificar sua reserva</li>
                <li>Políticas de cancelamento</li>
                <li>Métodos de pagamento aceitos</li>
              </ul>
            </div>
            <div className="help-topic">
              <h4>Durante Sua Estadia</h4>
              <ul>
                <li>Procedimentos de check-in</li>
                <li>Regras da casa</li>
                <li>Entrar em contato com seu anfitrião</li>
                <li>Relatar problemas</li>
              </ul>
            </div>
            <div className="help-topic">
              <h4>Após Sua Estadia</h4>
              <ul>
                <li>Deixar uma avaliação</li>
                <li>Obter um recibo</li>
                <li>Solicitar reembolso</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Para Anfitriões</h3>
          <div className="help-topics">
            <div className="help-topic">
              <h4>Começando</h4>
              <ul>
                <li>Criar um anúncio</li>
                <li>Definir seus preços</li>
                <li>Gerenciar calendário</li>
                <li>Fotos e descrições</li>
              </ul>
            </div>
            <div className="help-topic">
              <h4>Gerenciar Reservas</h4>
              <ul>
                <li>Aceitar reservas</li>
                <li>Comunicar com hóspedes</li>
                <li>Lidar com cancelamentos</li>
                <li>Check-in e check-out</li>
              </ul>
            </div>
            <div className="help-topic">
              <h4>Pagamentos e Impostos</h4>
              <ul>
                <li>Como você recebe pagamentos</li>
                <li>Entender as taxas</li>
                <li>Informações fiscais</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Ainda Precisa de Ajuda?</h3>
          <p>Não encontrou o que procura? Nossa equipe de suporte está aqui para ajudar 24/7.</p>
          <div className="contact-options">
            <Link to="/contact" className="btn-primary">Contatar Suporte</Link>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Help;
